import type { ReactNode } from "react";
import { useTenantFeatures } from "../../../contexts/tenant-features";
export function ProtocolAccess({ children }: { children: ReactNode }) {
  const { protocolsEnabled, loading, failed, refresh } = useTenantFeatures();
  if (loading)
    return (
      <p role="status" className="p-4">
        Carregando protocolos…
      </p>
    );
  if (failed)
    return (
      <div role="alert" className="app-page">
        Não foi possível consultar a habilitação.{" "}
        <button className="btn btn-secondary" onClick={refresh}>
          Tentar novamente
        </button>
      </div>
    );
  if (!protocolsEnabled)
    return (
      <p className="app-page">Protocolos desabilitados para este tenant.</p>
    );
  return <>{children}</>;
}
